import { RegisterProvider } from '../../../../components/account/RegisterProvider';

export const Page = () => {
  return <RegisterProvider />;
};
